export class PriceExchange {
  indexExchange: number;
  code: string;

  constructor(
    indexExchange: number,
    code: string,
  ) {
    this.indexExchange = indexExchange;
    this.code = code;
  }

  static fromRaw(raw: any): PriceExchange {
    return new PriceExchange(
      raw.indexExchange,
      String(raw.code),
    );
  }

  clone(): PriceExchange {
    return new PriceExchange(
      this.indexExchange,
      this.code,
    );
  }

  toPayload(): any {
    return {
      indexExchange: this.indexExchange,
      code: this.code,
    };
  }
}
